import { CardsWidgetMapped } from '../../_interfaces/dashboard.interface';

export enum CardsWidgetLabels {
  available = 'available',
  active = 'active',
  blocked = 'blocked',
  removed = 'removed',
  new = 'new',
  invites = 'invites',
}

export const cardDisplayData: CardsWidgetMapped[] = [
  {
    name: CardsWidgetLabels.available,
    details: {
      value: 0,
      label: 'Available',
      class: 'bg-available',
    },
  },
  {
    name: CardsWidgetLabels.active,
    details: {
      value: 0,
      label: 'Active',
      class: 'bg-active',
    },
  },
  {
    name: CardsWidgetLabels.new,
    details: {
      value: 0,
      label: 'New',
      class: 'bg-new',
    },
  },
  {
    name: CardsWidgetLabels.invites,
    details: {
      value: 0,
      label: 'Card invites',
      class: 'light-blue',
    },
  },
  {
    name: CardsWidgetLabels.blocked,
    details: {
      value: 0,
      label: 'Blocked',
      class: 'bg-blocked',
    },
  },
  {
    name: CardsWidgetLabels.removed,
    details: {
      value: 0,
      label: 'Removed',
      class: 'bg-removed',
    },
  },
];
